// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container___B4arP","list":"styles-module__list___R1pSG"};